// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navigation_navLink__1E1pN","navLinkActive":"Navigation_navLinkActive__1Q0l0"};